define('bizzabo/models/ExternalEventsCollection',['backbone', 'underscore', 'bizzabo/bzapi'], function(Backbone, _, BZAPI) {

    var ExternalEventsCollection = Backbone.Collection.extend({
        sync : function(method, model, options) {
            if (method == 'read' && this.provider) {
                BZAPI.importEvents(this.provider, function(data) {
                    options.success && options.success(data, options);
                }, options.error);
            }
        },

        model : Backbone.Model
    });

    return ExternalEventsCollection;

});
